export const alertsEn = {
  alerts: {
    title: "Alerts & Notifications",
    subtitle: "Stay informed about your farm conditions",
    activeAlerts: "Active Alerts",
    alertHistory: "Alert History",
    settings: "Alert Settings",
    priority: "Priority",
    high: "High",
    medium: "Medium",
    low: "Low",
    type: "Type",
    weather: "Weather",
    pest: "Pest",
    disease: "Disease",
    irrigation: "Irrigation",
    frost: "Frost",
    markAsRead: "Mark as Read",
    dismiss: "Dismiss",
    viewDetails: "View Details",
    noAlerts: "No active alerts",
    allClear: "All systems operating normally",
    filters: "Filters",
    searchAlerts: "Search alerts...",
    allSeverities: "All Severities",
    critical: "Critical",
    allStatus: "All Status",
    resolved: "Resolved",
    allTypes: "All Types",
    waterStress: "Water Stress",
    heatStress: "Heat Stress",
    cropStress: "Crop Stress",
    frostRisk: "Frost Risk",
    stormWarning: "Storm Warning",
    floodingRisk: "Flooding Risk",
    insuranceAlert: "Insurance Alert",
    generalRisk: "General Risk",
    totalAlerts: "Total Alerts",
    activeAlertsCount: "Active Alerts",
    criticalAlerts: "Critical Alerts",
    resolvedCount: "Resolved",
    allAlerts: "All Alerts",
    showingAlerts: "Showing {{filtered}} of {{total}} alerts",
    noAlertsFound: "No Alerts Found",
    noAlertsGenerated: "No alerts have been generated yet. Add parcels and generate analysis to receive alerts.",
    noAlertsMatch: "No alerts match your current filters. Try adjusting the search criteria.",
    resolve: "Resolve",
    viewParcel: "View Parcel",
    alertResolved: "Alert Resolved",
    alertResolvedDesc: "Alert has been marked as resolved.",
    alertResolveFailed: "Failed to resolve alert. Please try again.",
    loadingAlerts: "Loading alerts...",
    parcel: "Parcel",
    alertType: "Type",
    alertDetails: "Alert Details"
  }
};
